// General
export const PROJECT_NAME = 'Project Name'

// Mint pages
export const MINT_PAGE_TITLE = 'Mint your NFT now!'

export const MINT_NOSALE_TITLE = 'Sale not yet live!'
export const MINT_NOSALE_SUBTEXT = 'Come back soon!'

export const MINT_SOLDOUT_TITLE = 'Sold out!'
export const MINT_SOLDOUT_SUBTEXT = 'Find us on Opensea!'

export const MINT_BTN_TEXT = 'Mint'
export const MINT_SUPPLY_TEXT = 'Supply'
export const MINT_SUCCESS = 'Congrats on minting your NFT!'
export const MINT_FAIL_POOR = 'You don\'t have enought ETH!'
export const MINT_FAIL_GENERIC = 'Unable to mint!'
export const MINT_NOT_ALLOWLISTED = 'You aren\'t on the list!'
export const MINT_ALLOWANCE_EXCEEDED = 'You have claimed your allowance!'

export const WEBSITE_OUTDATED =
	'The website is outdated!\nPlease clear your browser cache.'

export const TX_PENDING = 'Tx Pending...'

// Social links
export const DISCORD_LINK = ''
export const TWITTER_LINK = ''
export const OPENSEA_LINK = ''
export const AOCOLLAB_LINK = 'https://block.aocollab.tech/'

// Landing Page
export const HERO_TITLE = 'Project Name'
export const HERO_DESCRIPTION =
	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.'
export const HERO_BUTTON_TEXT = 'Mint Now'
export const HERO_SUBTEXT =
	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida.'

export const ROADMAP_TITLE = 'Roadmap'

export const TEAM_MEMBER_TITLE = 'Team Members'
export const TEAM_MEMBERS = [
	{
		name: 'Team Member 1',
		image: 'avatar1.png',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.',
		twitter: 'team1',
	},
	{
		name: 'Team Member 2',
		image: 'avatar2.png',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.',
		twitter: '',
	},
	{
		name: 'Team Member 3',
		image: 'avatar3.png',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.',
		twitter: 'team3',
	},
	{
		name: 'Team Member 4',
		image: 'avatar4.png',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.',
		twitter: '',
	},
]

export const ABOUT_TITLE = 'About Us'
export const ABOUT_DESCRIPTION =
	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.'

export const FAQ_TITLE = 'FAQs'
export const FAQS = [
	{
		title: 'What is Project Name?',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida. Integer hendrerit nisl non magna blandit eleifend. Praesent mauris velit, ullamcorper nec ligula sed vestibulum.',
	},
	{
		title: 'What will the mint price be?',
		description:
			'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor iaculis gravida.',
	},
	{
		title: 'Wen Mint?',
		description: 'TBD',
	},
]
